<div class="gc-auth-footer">
    <p>{{ footerText }} {{ currentReleaseVersion }}</p>
  </div>
